<template>
  <v-app>
    <router-view />
    <v-footer class="secondary pa-5 white--text" v-if="['Subscription', 'SelfDiet'].indexOf($route.name) == -1 && !$route.name.includes('Payment')">
      <v-row>
        <v-col class="text-right">
          &copy;2020 SelfDiet - Tutti i diritti riservati
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>

<style>
#app.theme--light.v-application {
  background-color: white;
  font-family: "Titillium Web";
  letter-spacing: 0.1em;
}
#app.theme--light.v-application *:not(.v-icon) {
  font-family: "Titillium Web"!important;
  letter-spacing: 0.1em;
}
.v-card__title {
  word-break: normal!important;
}
</style>
